import React, { FC } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { User as UserContextType } from '../../../context/AuthContext';

interface ProfileDataProps {
  user: UserContextType;
}

const ProfileData: FC<ProfileDataProps> = ({ user }) => {
  return (
    <>
      {/* Linha 1: Dados básicos */}
      <Grid item xs={12} md={6}>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2">Email</Typography>
          <Typography variant="body1">{user.email}</Typography>
        </Box>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2">Telefone</Typography>
          <Typography variant="body1">{user.phone_number}</Typography>
        </Box>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2">CPF</Typography>
          <Typography variant="body1">{user.cpf || 'Não informado'}</Typography>
        </Box>
      </Grid>

      <Grid item xs={12} md={6}>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2">Ativo</Typography>
          <Typography variant="body1">
            {user.is_active ? 'Sim' : 'Não'}
          </Typography>
        </Box>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2">Último Login</Typography>
          <Typography variant="body1">
            {user.last_login ? new Date(user.last_login).toLocaleString() : '—'}
          </Typography>
        </Box>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2">Criado em</Typography>
          <Typography variant="body1">
            {new Date(user.created_at).toLocaleString()}
          </Typography>
        </Box>
      </Grid>
    </>
  );
};

export default ProfileData;